import React from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';

import type { AddContactWorkflow } from './workflow';

interface Props {
  workflow: AddContactWorkflow;
}

export function ForRecordInput({ workflow }: Props) {
  const { forRecordOptions, forRecordOption } = workflow;

  if (!forRecordOptions) {
    return null;
  }

  return (
    <ManagedFormGroup
      label={forRecordOptions.label}
      required
      type="select"
      value={forRecordOption?.value}
      onValueChange={
        value => workflow.change({ forRecordOption: forRecordOptions.options.find(option => option.value === value) })
      }
    >
      <Options options={forRecordOptions.options} />
    </ManagedFormGroup>
  );
}
